import React from 'react';
import Spinner from '@/components/ui/Spinner';
import i18n from 'i18n';

interface LoadingSpinnerProps {
    size?: number;
    color?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({size = 20, color = '#009efb'}) => (
    <Spinner 
        size="sm"
        text={i18n.t('loading_conversations.text')}
        centered
    />
);

export default LoadingSpinner;
